import React from 'react';
import { useAuth } from '../auth/AuthContext.js';
import AdminDashboard from './AdminDashboard.js';
import TimeEntry from '../time/TimeEntry.js';
import SupportWidget from './SupportWidgets';

function Dashboard() {
  const { user } = useAuth();

if (['superadmin', 'admin', 'adminassistant', 'manager'].includes(user.role)) {
  return <AdminDashboard />;
}

  // Show time cards page for employees and managers
  return (
    <>
      <TimeEntry />
      <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 999 }}>
        <SupportWidget />
      </div>
    </>
  );
}

export default Dashboard;